"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var TizenLifecycle = (function (_super) {
    __extends(TizenLifecycle, _super);
    function TizenLifecycle(window) {
        var _this = _super.call(this) || this;
        _this.window = window;
        _this.resumingObserver = new client_lib_js_player_addons_common_player_1.Observable();
        _this.suspendingObserver = new client_lib_js_player_addons_common_player_1.Observable();
        window.document.addEventListener('visibilitychange', function () {
            if (window.document.hidden) {
                _this.suspendingObserver.notifyObservers({});
            }
            else {
                _this.resumingObserver.notifyObservers({});
            }
        });
        return _this;
    }
    TizenLifecycle.prototype.onResuming = function (handler) {
        this.resumingObserver.registerObserver(handler, this);
        return true;
    };
    TizenLifecycle.prototype.onSuspending = function (handler) {
        this.suspendingObserver.registerObserver(handler, this);
        return true;
    };
    TizenLifecycle.prototype.exitApplication = function () {
        this.window.tizen.application.getCurrentApplication().exit();
    };
    return TizenLifecycle;
}(client_lib_js_player_addons_common_player_1.Lifecycle));
exports.TizenLifecycle = TizenLifecycle;
